<template lang="pug">
  app-modal.modalModelo(
    @closeModal="$emit('closeModal')"
    :titulo="titulo"
    :width="1100"
  )
    template(slot="body")
      template(v-if="modelo.tipoModelo === 'Modelo de Título Reurb'")
        div.campo-filtro-reurb
          div
            p Município:
            el-select.full-width.input(
              :value="modelo.idMunicipio",
              placeholder="Selecione o município",
              disabled
            )
              el-option(
                v-for="municipio in municipiosComSelecionado",
                :key="municipio.id",
                :label="municipio.nome",
                :value="municipio.id"
              )
          div.input-reurb
            p Reurb Coletivo:
            el-select.full-width.input(
              :value="modelo.idReurbColetivo",
              placeholder="Selecione o Reurb Coletivo",
              disabled
            )
              el-option(
                v-for="reurb in reurbColetivosComSelecionado",
                :key="reurb.id",
                :label="`${reurb.numeroProcesso} - ${reurb.nomeRazaoSocialInteressado}`",
                :value="reurb.id"
              )
          div
            p Tipo Reurb:
            el-select.full-width.input(
              :value="tipoReurbFormatado",
              placeholder="Selecione o tipo",
              disabled
            )
              el-option(label="REURB S", value="REURB_S")
              el-option(label="REURB E", value="REURB_E")
        .group.mt-1

      div.group
        p.label-text {{modelo.tipoModelo === 'Modelo de Título Reurb' ? 'Modelo de Título' : 'Despacho'}}:
        div.container(v-html="modelo.textoModelo")

      div(v-if="modelo.tipoModelo === 'Modelo de Título Reurb' && imagensAssinaturas.length > 0").group
        p.label-text Assinaturas:&nbsp
        app-anexo(
          :files="imagensAssinaturas",
          :id="'visualizar-assinaturas-modelo'",
          :fileType="['png', 'jpg', 'jpeg']",
          :exibirDownload="true",
          :exibirDelete="false",
          :showUpload="false",
          @downloadDocumentoCadastro="downloadDocumentoCadastro"
        ).container

    template(v-if="ativaBotaoVoltar" slot="footer")
      el-button(@click="$emit('closeModal')")
        i.el-icon-arrow-left
        | &nbsp;Voltar
</template>

<script>
import AppModal from '@/components/AppModal'
import AppAnexo from '@/components/AppAnexo'
import AppNotificacao from '@/components/mixins/AppNotificacao'
import { mapActions } from 'vuex'
import axios from '@/utils/api'
import FileSaver from 'file-saver'

export default {
  components: {
    AppModal,
    AppAnexo
  },

  mixins: [
    AppNotificacao
  ],

  props: {
    modelo: {
      type: Object,
      required: true
    },
    titulo: {
      type: String,
      required: true
    },
    ativaBotaoVoltar: {
      type: Boolean,
      default: false
    }
  },

  data () {
    return {
      municipios: [],
      reurbColetivos: [],
      imagensAssinaturas: []
    }
  },

  async mounted () {
    if (this.modelo.tipoModelo === 'Modelo de Título Reurb' && process.env.ESTADO === 'ma') {
      await this.carregarDadosReurb()
    }

    if (this.modelo.tipoModelo === 'Modelo de Título Reurb') {
      if (this.modelo.documentos && this.modelo.documentos.length > 0) {
        this.imagensAssinaturas = [...this.modelo.documentos]
      } else if (this.modelo.assinaturas && this.modelo.assinaturas.length > 0) {
        this.imagensAssinaturas = [...this.modelo.assinaturas]
      } else {
        this.imagensAssinaturas = []
      }
    }
  },

  computed: {
    isMaranhao () {
      return process.env.ESTADO === 'ma'
    },
    tipoReurbFormatado () {
      if (!this.modelo.tipoReurb) {
        return null
      }
      if (this.modelo.tipoReurb === 'REURB_S' || this.modelo.tipoReurb === 'REURB S') {
        return 'REURB_S'
      } else if (this.modelo.tipoReurb === 'REURB_E' || this.modelo.tipoReurb === 'REURB E') {
        return 'REURB_E'
      }
      return this.modelo.tipoReurb
    },
    municipiosComSelecionado () {
      if (!this.modelo.idMunicipio || !this.modelo.nomeMunicipio) {
        return this.municipios
      }
      const municipioSelecionado = this.municipios.find(m => m.id === this.modelo.idMunicipio)
      if (municipioSelecionado) {
        return this.municipios
      }
      return [
        ...this.municipios,
        { id: this.modelo.idMunicipio, nome: this.modelo.nomeMunicipio }
      ]
    },
    reurbColetivosComSelecionado () {
      if (!this.modelo.idReurbColetivo || !this.modelo.numeroProcessoReurbColetivo) {
        return this.reurbColetivos
      }
      const reurbSelecionado = this.reurbColetivos.find(r => r.id === this.modelo.idReurbColetivo)
      if (reurbSelecionado) {
        return this.reurbColetivos
      }
      return [
        ...this.reurbColetivos,
        { id: this.modelo.idReurbColetivo, numeroProcesso: this.modelo.numeroProcessoReurbColetivo }
      ]
    }
  },

  methods: {
    ...mapActions({
      buscarReurbColetivosPorMunicipio: 'modeloDespacho/buscarReurbColetivosPorMunicipio',
      findMunicipiosByEstadoAtual: 'municipios/findMunicipiosByEstadoAtual'
    }),

    async carregarDadosReurb () {
      if (this.isMaranhao) {
        const municipiosData = await this.findMunicipiosByEstadoAtual()
        this.municipios = municipiosData || []

        if (this.modelo.idMunicipio) {
          await this.buscarReurbColetivos()
        }
      }
    },

    async buscarReurbColetivos () {
      if (this.modelo.idMunicipio) {
        try {
          const response = await this.buscarReurbColetivosPorMunicipio(this.modelo.idMunicipio)
          this.reurbColetivos = response || []
        } catch (error) {
          this.reurbColetivos = []
          this.showNotificacao(this.$messages.TIPO_ERROR, this.$messages.TITULO_ERROR, 'Erro ao buscar Reurb Coletivos')
        }
      } else {
        this.reurbColetivos = []
      }
    },

    async downloadDocumentoCadastro (documento) {
      const file = await axios({
        method: 'POST',
        url: `documento/file`,
        data: documento,
        responseType: 'blob'
      })
      FileSaver.saveAs(file, documento.nome)
    }
  }
}
</script>

<style scoped lang="scss">
.container {
  padding: 20px;
  border: 0.5px solid #e0e0e0;
  border-radius: 6px;
  background-color: #f5f5f5;
}

.group {
  padding: 30px;
}

.group:not(:first-child) {
  margin: 5px 0;
}

.campo-filtro-reurb {
  display: flex;
  gap: 10px;
  justify-content: center;
}

.label-text {
  font-family: sans-serif;
  font-size: 18px;
  margin: 10px 0;
  font-weight: bold;
  color: black;
}

.input-reurb {
  flex: 0 0 35%;
}

@media (max-width: 780px) {
  .modalModelo {
    position: fixed !important;
    width: 395px !important;
  }

  .campo-filtro-reurb {
    flex-direction: column;
    gap: 20px;
  }

  .input-reurb {
    flex: 1;
    width: 100%;
  }
}
</style>



// WEBPACK FOOTER //
// src/screens/analise/components/AppModalVisualizarModelo.vue